module.exports = __webpack_public_path__ + "img/subscribe_bg_aau.81e8d82b.jpg";